import TagModule from './tag.module'

export default TagModule
